// Project Type Constants
export enum ProjectType {
  Income = 1,
  Expense = 2
}

// Project Status Constants
export enum ProjectStatus {
  Request = 1,
  Canceled = 2,
  InProgress = 3,
  Completed = 4,
  Support = 5,
  Lead = 6,
  Opportunity = 7,
  Rejected = 8
}

// Project Category Constants
export enum ProjectCategory {
  RevenueDevelopment = 0,
  RevenueConsulting = 1,
  RevenueTraining = 2,
  RevenueLicensing = 3,
  RevenuePartnership = 4,
  RevenueGrants = 5,
  CostTechnicalSalaries = 6,
  CostEquipment = 7,
  CostToolsLicenses = 8,
  CostSubscriptions = 9,
  CostOther = 10,
  OpexMarketingSalaries = 11,
  OpexAdvertising = 12,
  OpexExhibitionsEvents = 13,
  OpexAdministrativeSalaries = 14,
  OpexOfficeRent = 15,
  OpexBankFees = 16,
  OpexResearchDevelopment = 17,
  OpexEmployeeTraining = 18,
  OpexLegalFinancial = 19,
  OpexOtherOperational = 20,
  Taxes = 21,
  Depreciation = 22,
  InterestIncome = 23,
  InterestExpenses = 24,
  RevenueExchangeDifferences = 25,
  ExpensesExchangeDifferences = 26,
  ExpensesBankCommissions = 27,
  RevenueDigitalProduct = 28,
  CostCSP = 29
}

// Transaction Category Constants
export enum TransactionCategory {
  AllCategories = -2,
  NoCategory = -1,
  Development = 1,
  Design = 2,
  Marketing = 3,
  Support = 4,
  Management = 5
}

// Transaction Direction/Source Constants
export enum TransactionDirection {
  NoValue = -2,
  All = -1,
  Alex = 1,
  Mike = 2
}

// Filter All Options
export const FILTER_ALL = -1;
export const FILTER_NO_VALUE = -2;

// Project Category Labels
export const PROJECT_CATEGORY_LABELS: Record<number, string> = {
  [ProjectCategory.RevenueDevelopment]: 'Дохід - Розробка',
  [ProjectCategory.RevenueConsulting]: 'Дохід - Консалтінг',
  [ProjectCategory.RevenueTraining]: 'Дохід - Навчання',
  [ProjectCategory.RevenueLicensing]: 'Дохід - Ліцензування',
  [ProjectCategory.RevenuePartnership]: 'Дохід - Партнерські',
  [ProjectCategory.RevenueGrants]: 'Дохід - Гранти',
  [ProjectCategory.CostTechnicalSalaries]: 'Зарплати технічної команди (собівартість)',
  [ProjectCategory.CostEquipment]: 'Техніка (собівартість)',
  [ProjectCategory.CostToolsLicenses]: 'Інструменти та ліцензії (собівартість)',
  [ProjectCategory.CostSubscriptions]: 'Підписки (собівартість)',
  [ProjectCategory.CostOther]: 'Інші витрати (собівартість)',
  [ProjectCategory.OpexMarketingSalaries]: 'Зарплати маркетингової команди (Операційні витрати)',
  [ProjectCategory.OpexAdvertising]: 'Реклама (Операційні витрати)',
  [ProjectCategory.OpexExhibitionsEvents]: 'Виставки та події (Операційні витрати)',
  [ProjectCategory.OpexAdministrativeSalaries]: 'Зарплати адміністративного персоналу (Операційні витрати)',
  [ProjectCategory.OpexOfficeRent]: 'Оренда офісу (Операційні витрати)',
  [ProjectCategory.OpexBankFees]: 'Платежі за банківські послуги (Операційні витрати)',
  [ProjectCategory.OpexResearchDevelopment]: 'Дослідження та розробки (Операційні витрати)',
  [ProjectCategory.OpexEmployeeTraining]: 'Навчання співробітників (Операційні витрати)',
  [ProjectCategory.OpexLegalFinancial]: 'Юридичні та фінансові послуги (Операційні витрати)',
  [ProjectCategory.OpexOtherOperational]: 'Інші операційні витрати (Операційні витрати)',
  [ProjectCategory.Taxes]: 'Податки',
  [ProjectCategory.Depreciation]: 'Амортизація',
  [ProjectCategory.InterestIncome]: 'Процентні доходи',
  [ProjectCategory.InterestExpenses]: 'Процентні витрати',
  [ProjectCategory.RevenueExchangeDifferences]: 'Доходи: Курсові різниці',
  [ProjectCategory.ExpensesExchangeDifferences]: 'Витрати: Курсові різниці',
  [ProjectCategory.ExpensesBankCommissions]: 'Витрати: Банк та комісії',
  [ProjectCategory.RevenueDigitalProduct]: 'Дохід - Digital Product',
  [ProjectCategory.CostCSP]: 'CSP (собівартість)'
};

// Status Badge Classes
export const STATUS_BADGE_CLASSES: Record<number, string> = {
  [ProjectStatus.Request]: 'bg-info',
  [ProjectStatus.Canceled]: 'bg-danger',
  [ProjectStatus.InProgress]: 'bg-primary',
  [ProjectStatus.Completed]: 'bg-success',
  [ProjectStatus.Support]: 'bg-warning'
};

// Status Labels
export const PROJECT_STATUS_LABELS: Record<number, string> = {
  [ProjectStatus.Request]: 'Request',
  [ProjectStatus.Canceled]: 'Canceled',
  [ProjectStatus.InProgress]: 'In Progress',
  [ProjectStatus.Completed]: 'Completed',
  [ProjectStatus.Support]: 'Support',
  [ProjectStatus.Lead]: 'Lead',
  [ProjectStatus.Opportunity]: 'Opportunity',
  [ProjectStatus.Rejected]: 'Rejected'
};

// Transaction Category Labels
export const TRANSACTION_CATEGORY_LABELS: Record<number, string> = {
  [TransactionCategory.AllCategories]: 'All categories',
  [TransactionCategory.NoCategory]: 'No category',
  [TransactionCategory.Development]: 'Development',
  [TransactionCategory.Design]: 'Design',
  [TransactionCategory.Marketing]: 'Marketing',
  [TransactionCategory.Support]: 'Support',
  [TransactionCategory.Management]: 'Management'
};

// Transaction Direction Labels
export const TRANSACTION_DIRECTION_LABELS: Record<number, string> = {
  [TransactionDirection.NoValue]: 'No value',
  [TransactionDirection.All]: 'All',
  [TransactionDirection.Alex]: 'Alex',
  [TransactionDirection.Mike]: 'Mike'
};
